<template>
  <div class="idea-comment-section">
    <div class="rating-wrapper-header">
      <div class="heading">Bewertungen</div>
      <div class="rating-sorting">
        <img src="/img/icons/sort-desc.svg" /> Neuste zuerst
      </div>
    </div>

    <div class="rating-container">
      <div class="no-ratings" v-if="ratings.length < 1">
        Es wurden noch keine Bewertungen abgegeben.
      </div>
      <div v-for="rating in ratings" :key="rating.id" class="rating">
        <div class="rating-meta">
          <div class="user-avatar">
            <img
              :src="
                rating.user.avatar || '/img/placeholder/avatar_placeholder.svg'
              "
            />
          </div>
          <div class="user-name">{{ rating.user.name }}</div>
          <div class="rating-date">am {{ rating.created_at }}</div>
        </div>
        <div class="rating-header">
          <div class="rating-stars">
            <img
              v-for="n in Math.floor(rating.rating)"
              :key="'star' + n"
              src="/img/icons/star-full.svg"
            />
            <img
              v-for="n in Math.floor(5 - rating.rating)"
              :key="'empty' + n"
              src="/img/icons/star-empty.svg"
            />
          </div>

          <div class="rating-title">{{ rating.title }}</div>
        </div>
        <div class="rating-content">{{ rating.description }}</div>
      </div>
    </div>

    <div
      id="create-rating"
      class="create-rating-wrapper"
      v-if="
        authenticated &&
        creator !== authenticated.id &&
        already !== true &&
        alreadyFresh !== true
      "
    >
      <div class="create-rating-header">Idee bewerten</div>
      <div class="create-meta">
        <div class="create-stars">
          <v-rating hover length="5" size="36" v-model="rating"></v-rating>
        </div>
        <div class="create-user">
          <img
            :src="
              authenticated.avatar || '/img/placeholder/avatar_placeholder.svg'
            "
          />
          {{ authenticated.name }}
        </div>
      </div>
      <div class="create-form">
        <div class="create-row">
          <label class="input-label">Titel </label>
          <input class="input-text" v-model="title" type="text" />
          <p v-if="titleMissing" class="small error-message">
            Bitte gib einen Titel an
          </p>
        </div>
        <div class="create-row">
          <label class="input-label">Bewertung </label>
          <textarea v-model="content" class="input-text text-area"></textarea>
          <p v-if="descriptionMissing" class="small error-message">
            Bitte gib eine Beschreibung an
          </p>
        </div>
      </div>
      <div class="create-additional">
        <div class="create-image-container"></div>
        <button @click.prevent="sendRating()" class="btn btn-blue">
          <img :src="'/img/icons/star-empty-blue.svg'" />
          Bewertung abgeben
        </button>
      </div>
    </div>
    <div
      class="create-rating-wrapper"
      id="create-rating "
      v-if="authenticated === undefined || authenticated === false"
    >
      <div class="create-rating-header">Idee bewerten</div>
      <div class="not-authenticated">
        <a href="/login">
          Du musst eingeloggt sein, um eine Idee bewerten zu können.
        </a>
      </div>
    </div>

    <div
      class="create-rating-wrapper"
      id="create-rating "
      v-if="already === true || alreadyFresh === true"
    >
      <div class="create-rating-header">Idee bewerten</div>
      <div class="not-authenticated">Du hast diese Idee bereits bewertet.</div>
    </div>

    <div
      class="create-rating-wrapper"
      id="create-rating "
      v-if="authenticated && authenticated.id === creator"
    >
      <div class="create-rating-header">Idee bewerten</div>
      <div class="not-authenticated">
        Du kannst deine eigene Idee nicht bewerten.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["idea_id", "ratingsIncoming", "authenticated", "already", "creator"],
  data() {
    return {
      content: "",
      title: "",
      rating: 2.5,
      ratings: this.ratingsIncoming,
      alreadyFresh: this.already,
      titleMissing: false,
      descriptionMissing: false
    };
  },
  watch: {},
  methods: {
    fullStars(rating) {
      console.log("full", rating);
      return Math.floor(rating);
    },
    emptyStars(rating) {
      console.log("empty");
      return Math.floor(5 - rating);
    },
    validateInput() {
      let ok = true;
      this.titleMissing = false;
      this.descriptionMissing = false;

      if (this.title === "" || this.title === null) {
        this.titleMissing = true;
        ok = false;
      }
      if (this.content === "" || this.content === null) {
        this.descriptionMissing = true;
        ok = false;
      }

      return ok;
    },

    async sendRating() {
      if (this.validateInput()) {
        axios
          .post("/rating", {
            rating: this.rating,
            title: this.title,
            content: this.content,
            idea_id: this.idea_id,
          })
          .then((res) => {
            // console.log(res.status);
            // console.log("sent");
            if (res.status == 201) {
              this.alreadyFresh = true;
              this.ratings.push(res.data.rating);
              this.rating = 0;
              this.title = "";
              this.content = "";
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    console.log("mounted");
  },
  created() {
    console.log("created");
  },
  beforeCreate() {},
  computed: {},
};
</script>

<style>
</style>
